import React, { useRef, useState } from "react";
import { ZTypography } from "@atoms";
import ZTryWithAiCard from "./ZTryWithAiCard";
import { IZTryWithAiButtonProps } from "./interface";
import ZTryWithAiInput from "./ZTryWithAiInput";
import { cache } from "@/Contracts";
import TryWithAiStars from "./tryWithAiStars.svg";
import "./index.less";
import { Skeleton } from "antd";

const ZTryWithAiButton: React.FC<IZTryWithAiButtonProps> = ({
	onOpen,
	onCancel,
	inputValue,
	onInputChange,
	loadingGenerateFormula,
	onGenerateFormula
}) => {
	const TRYWITHAICARDGUIDEHIDE = "tryWithAiCardGuideHide";
	const [showTryWithAiCard, setShowTryWithAiCard] = useState(false);
	const [isInputVisible, setIsInputVisible] = useState(false);
	const onCloseTryWithAiCard = () => {
		cache.save(TRYWITHAICARDGUIDEHIDE, true);
		setShowTryWithAiCard(false);
	};
	const mouseOutTimer = useRef<NodeJS.Timeout | null>(null);
	return (
		<div className={`relative ${isInputVisible ? "w-full" : "w-max"}`}>
			{!isInputVisible && (
				<div
					className="z-try-with-ai-button"
					onClick={() => {
						onCloseTryWithAiCard();
						onOpen();
						setIsInputVisible(true);
					}}
					onMouseOver={() => {
						if (mouseOutTimer.current)
							clearTimeout(mouseOutTimer.current);
						setShowTryWithAiCard(true);
					}}
					onMouseOut={() => {
						mouseOutTimer.current = setTimeout(() => {
							setShowTryWithAiCard(false);
						}, 200);
					}}
				>
					<div>
						<TryWithAiStars className="mx-0 mr-2" />
						<ZTypography.ZText>Try with AI</ZTypography.ZText>
					</div>
				</div>
			)}
			{isInputVisible && (
				<Skeleton
					active
					paragraph={false}
					loading={loadingGenerateFormula}
				>
					<ZTryWithAiInput
						onCancel={() => {
							setIsInputVisible(false);
							onCancel();
						}}
						inputValue={inputValue}
						onInputChange={onInputChange}
						onGenerateFormula={onGenerateFormula}
					/>
				</Skeleton>
			)}
			{showTryWithAiCard && !cache.get(TRYWITHAICARDGUIDEHIDE) && (
				<ZTryWithAiCard
					onMouseOver={() => {
						if (mouseOutTimer.current)
							clearTimeout(mouseOutTimer.current);
					}}
					onMouseOut={() => {
						mouseOutTimer.current = setTimeout(() => {
							setShowTryWithAiCard(false);
						}, 200);
					}}
					className="absolute bottom-10 right-0"
					onClose={onCloseTryWithAiCard}
				/>
			)}
		</div>
	);
};

export default ZTryWithAiButton;
